import { lazy } from 'react';

export const MainPage = lazy(() => import('./MainPage'));
